import { useEffect, useMemo, useState } from 'react';
import { buildRequestQueueSummary, filterRequestsByQueue } from '../components/requests/requestUtils';

function useOperationalRequestQueue({
  initialFilter = 'all',
  requests = [],
  onSelectionCleared = null
}) {
  const [selectedRequestId, setSelectedRequestId] = useState('');
  const [requestFilter, setRequestFilter] = useState(initialFilter);
  const [localRequests, setLocalRequests] = useState(requests);

  useEffect(() => {
    setLocalRequests(requests);
  }, [requests]);

  const requestSummary = useMemo(() => buildRequestQueueSummary(localRequests), [localRequests]);
  const filteredRequests = useMemo(
    () => filterRequestsByQueue(localRequests, requestFilter),
    [localRequests, requestFilter]
  );

  useEffect(() => {
    if (!filteredRequests.some((request) => String(request.id) === String(selectedRequestId))) {
      setSelectedRequestId('');
      onSelectionCleared?.();
    }
  }, [filteredRequests, onSelectionCleared, selectedRequestId]);

  const selectedRequest = useMemo(
    () => localRequests.find((request) => String(request.id) === String(selectedRequestId)) || null,
    [localRequests, selectedRequestId]
  );

  return {
    filteredRequests,
    localRequests,
    requestFilter,
    requestSummary,
    selectedRequest,
    selectedRequestId,
    setLocalRequests,
    setRequestFilter,
    setSelectedRequestId
  };
}

export default useOperationalRequestQueue;
